




































































































import { Component, Vue, Watch } from "vue-property-decorator";
import NavAsideVue from "@/components/app/NavAside.vue";
import MainHeaderVue from "@/components/app/MainHeader.vue";
import NavMiddleVue from "@/components/app/NavMiddle.vue";
import DragBarVue from "@/components/DragBar.vue";
import PrintVue from "@/views/Print.vue";
// import UpdateVue from "@/views/Update.vue";
import ArchiveVue from "@/views/Archive.vue";
// import DownloadVue from "@/views/Download.vue";
import TipTextVue from "@/components/TipText.vue";
import VoucherPrintVue from "@/views/VoucherPrint.vue";
import ViewAccountBookVue from "@/components/AccountBookList/ViewAccountBook.vue";
import MemoryBallVue from "@/components/app/MemoryBall.vue";
import UpdateNoticeVue from "@/components/app/UpdateNotice.vue";
import VoucherListVue from "@/views/VoucherList.vue";
import UrlControllerVue from "@/components/UrlController.vue";
import { mapGetters } from "vuex";
// import { ipcRenderer } from "electron";
import { Route } from "vue-router";
import TabsVue from "@/components/app/Tabs.vue";

@Component({
	...mapGetters([
		"updateState",
		"accountBook",
		"account",
		"historyLength",
		"currentPos",
	]),
	components: {
		"nav-aside": NavAsideVue,
		"main-header": MainHeaderVue,
		"nav-middle": NavMiddleVue,
		"drag-bar": DragBarVue,
		print: PrintVue,
		archive: ArchiveVue,
		// download: DownloadVue,
		tip: TipTextVue,
		"voucher-print": VoucherPrintVue,
		"view-book": ViewAccountBookVue,
		"mem-bal": MemoryBallVue,
		"update-notice": UpdateNoticeVue,
		"url-controller": UrlControllerVue,
		tab: TabsVue,
	},
})
export default class App extends Vue {
	isJzs = process.env.VUE_APP_TITLE === "jzs";
	isProd = process.env.VUE_APP_TITLE === "production";
	navWidth: number = 70;
	// 打印dialog的显示val
	printVisble: boolean = false;
	// 归档的显示val
	archVisble: boolean = false;
	// 打印凭证dialog
	voucherPrintVisble: boolean = false;
	vouchers: Voucher.Voucher[] = [];
	// 查看账套dialog
	bookVisible: boolean = false;
	// 是否为小屏幕
	isSmallScreen: boolean = false;
	asideVisible: boolean = false;

	//是否展示更新
	showNotice: boolean = localStorage.getItem("showNotice") === "true";
	// showNotice: boolean = false;

	setTitle(val: Route) {
		document.title = `${val.meta.name}${this.$store.state.accountBook.bookName ? " - " + this.$store.state.accountBook.bookName : ""}`;
	}

	get isOut() {
		return this.$route.meta.icon !== undefined;
	}
	
	mounted() {
		let isJzs = process.env.VUE_APP_TITLE === "jzs";
		if (isJzs && this.$store.state.account.role === "管理员" && this.$store.state.freeDays > 0) {
			let msg = "试用" + this.$store.state.account.freeDays + "天到期！"
			this.$message({
				showClose: false,
				duration: 0,
				message: msg,
				type: "error"
			});
		}
		let zoom = localStorage.getItem("zoomValue");
		if (zoom) {
			this.$utils.sendToElectron("zoomChange", +zoom);
		}

		this.$store.dispatch("changeCurrentIcon", this.$route.meta.icon);
		this.setTitle(this.$route);

		// ipcRenderer.on("printers-got", (event: any, content: string) => {
		// 	const printers = JSON.parse(content);
		// 	printers.push({
		// 		name: "保存为PDF",
		// 		description: "pdf printer",
		// 	});
		// 	this.$store.dispatch("getPrinters", printers);
		// });
		// this.$router.push("/accountbooklist");
		// ipcRenderer.on("smallScreen", (e: Electron.Event, size: any) => {
		// 	this.isSmallScreen = true;
		// });
		// ipcRenderer.on("normalScreen", (e: Electron.Event, size: any) => {
		// 	this.isSmallScreen = false;
		// });
		// // insiderUpdate
		// ipcRenderer.on("insiderUpdate", () => {
		// 	this.$utils.updateHandle("partUpdate", false);
		// });
	}

	env() {
		return process.env.NODE_ENV;
	}
	showNot(val: boolean) {
		if (val) {
			this.showNotice = localStorage.getItem("showNotice") === "true"
		}
	}

	isSkin() {
		let showSkin = <NavAsideVue>this.$refs.showSkin;
		showSkin.showSkin = false;
	}

	printPeriod: Date | null = null;
	openPrint(period?: Date) {
		this.printVisble = true;
		if (period) this.printPeriod = period;
		else this.printPeriod = null;
	}

	// 全局搜索
	globalSearch() {
		// @ts-ignore
		if (this.$refs.workChild && this.$refs.workChild.fetchData) {
			// @ts-ignore
			if (this.$refs.workChild.activeName === "客户列表") {
				// @ts-ignore
				this.$refs.workChild.getFetch();
				// @ts-ignore
			} else {
				// @ts-ignore
				if (this.$refs.workChild.currentPage && this.$route.path === "/charge") this.$refs.workChild.currentPage = 1;
				// @ts-ignore
				this.$refs.workChild.fetchData();
			}
		}
	}

	openArchive() {
		this.archVisble = true;
	}

	closeDownload() {
		this.$store.dispatch("toggleDownload", false);
	}

	openVoucherPrint(vouchers: Voucher.Voucher[]) {
		this.vouchers = this.$utils.pageableVoucher(
			this.$store.state.voucherRows,
			vouchers
		);
		this.voucherPrintVisble = true;
	}

	leaveAside() {
		if (this.isSmallScreen) {
			this.asideVisible = false;
		}
	}

	// 内存球
	showMemBall: boolean = false;
	// 切换账套刷新
	changeBook() {
		this.$store.state.tabs = [
			{
				url: "/",
				name: "主页",
			},
		];
		this.$store.state.currentTab = 0;
		if (
			this.$refs.workChild &&
			(<VoucherListVue>this.$refs.workChild).fetchPeriod
		)
			(<VoucherListVue>this.$refs.workChild).fetchPeriod();
	}

	// 前进后退导航
	get forwardDisabled() {
		return this.$store.state.currentPos > -1;
	}
	get backDisabled() {
		return (
			this.$store.state.historyLength < 1 ||
			Math.abs(this.$store.state.currentPos) >=
			this.$store.state.historyLength
		);
	}

	goBack() {
		if (!this.backDisabled) {
			this.$store.dispatch(
				"currentPosChange",
				this.$store.state.currentPos - 1
			);
			this.$store.dispatch(
				"historyChange",
				this.$store.state.historyLength - 1
			);
			this.$router.go(-1);
		}
	}
	goForward() {
		if (!this.forwardDisabled) {
			this.$store.dispatch(
				"currentPosChange",
				this.$store.state.currentPos + 1
			);
			this.$store.dispatch(
				"historyChange",
				this.$store.state.historyLength - 1
			);
			this.$router.go(1);
		}
	}
	@Watch("$route")
	routeChanged(val: Route) {
		this.$store.dispatch(
			"historyChange",
			this.$store.state.historyLength + 1
		);
		if (val.meta.icon) {
			this.$store.dispatch("changeCurrentIcon", val.meta.icon);
			this.$store.state.tabs = [
				{
					url: "/",
					name: "主页",
				},
			];
			this.$store.state.currentTab = 0;
		} else if (this.$store.state.accountBook.bookName === "") {
			// @ts-ignore
			this.$store.dispatch("changeCurrentIcon", "记账", true);
		} else {
			this.$set(this.$store.state.tabs, 0, {
				url: val.path,
				name: val.meta.name ? val.meta.name : "主页",
			});
			this.$store.state.currentTab = 0;
		}
	}

	botVisible = false;
	botTipVisible = false;
	enterBot() {
		this.botVisible = true;
		setTimeout(() => {
			this.botTipVisible = true;
		}, 200);
	}
	leaveBot() {
		this.botTipVisible = false;
		this.botVisible = false;
	}
	autoShowBot() {
		if (!this.isProd) {
			this.botVisible = true;
			setTimeout(() => {
				this.botTipVisible = true;
			}, 200);
			setTimeout(this.leaveBot, 10000);
		}
	}
	timer: NodeJS.Timeout | null = null;
	created() {
		this.autoShowBot();
		if (this.timer !== null) clearInterval(this.timer);
		this.timer = setInterval(this.autoShowBot, 1000 * 60 * 5);
	}
}
